import React from "react";
import { GoClock } from "react-icons/go";

export const Hours = ({ hours }) => {
  const sameWeekdayHours = () => {
    return (
      hours.monday == hours.tuesday &&
      hours.monday == hours.wednesday &&
      hours.monday == hours.thursday &&
      hours.monday == hours.friday
    );
  };

  const sameWeekendHours = () => {
    return hours.saturday == hours.sunday;
  };

  if (hours.useSupportHours) {
    return (
      <section>
        <div className="pb-3">
          <p>
            Our live support team is available at{" "}
            <a href="mailto:support@printwithme.com">support@printwithme.com</a>{" "}
            and <a href="tel:1+773-797-2118">+773-797-2118</a>.
          </p>
        </div>

        <section className="hours">
          <p>
            <i>Our support hours are as below:</i>
          </p>

          <div className="mt-1">
            <ul>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                M-F: {hours.monday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Sat & Sun: {hours.saturday}
              </li>
            </ul>
          </div>
        </section>
      </section>
    );
  }

  return (
    <section className="hours">
      <p>
        <i>Hours may vary</i>
      </p>

      <div className="mt-1">
        <ul>
          {sameWeekdayHours() ? (
            <li>
              <span className="pe-2">
                <GoClock />
              </span>
              M-F: {hours.monday}
            </li>
          ) : (
            <>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Mon: {hours.monday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Tue: {hours.tuesday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Wed: {hours.wednesday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Thu: {hours.thursday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Fri: {hours.friday}
              </li>
            </>
          )}
          {sameWeekendHours() ? (
            <li>
              <span className="pe-2">
                <GoClock />
              </span>
              Sat & Sun: {hours.saturday}
            </li>
          ) : (
            <>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Sat: {hours.saturday}
              </li>
              <li>
                <span className="pe-2">
                  <GoClock />
                </span>
                Sun: {hours.sunday}
              </li>
            </>
          )}
        </ul>
      </div>
    </section>
  );
};
